export class AuthTokenInfo {
    accessToken: string;
    refreshToken: string;
}